<template>
	<div class="detail">
		<!-- 面包屑 -->
		<div class="Breadcrumb">
			<img @click="$router.replace('/Layout/Home')" src="@img/icon/ui_home_page_0.png" alt />
			<a @click="$router.replace('/Layout/Home')">首页 &nbsp;/ &nbsp;</a>
			<a @click="$router.push('/Layout/learnmodel')">学习模式 &nbsp;/ &nbsp;</a>
			<a class="active" v-if="type == 0">{{ title }}</a>
			<a class="active" v-if="type == 1">完整动作</a>
			<a class="active" v-if="type != 0 && type != 1">跳远动作子模块-{{ title }}</a>
		</div>
		<div class="main_box">
			<div class="detai_box">
				<div class="video_box">
					<video v-if="videoId !== '3dvideo'" :src="videoifo.video ? videoifo.video : ''" :poster="videoifo.cover ? videoifo.cover : ''" controls controlslist="nodownload noremoteplayback" :disablePictureInPicture="true"></video>
					<iframe v-else :src="iframeSrc" frameborder="0"></iframe>
					<!-- 3D模型开始 -->
					<div></div>
					<!-- 3D模型结束 -->
					<div v-if="type !=0 && isShow3d && type !=6" class="video_title">3D演示</div>
					<div v-else class="video_title">{{ videoifo.name }}</div>
				</div>
				<div class="video_detail_box">
					<div class="text_box">
						<div v-if="type !=0 && isShow3d && type !=6" class="text_title">3D演示</div>
						<div v-else class="text_title">{{ videoifo.name }}</div>
						<div v-if="type !=0 && isShow3d && type !=6" class="text_introduce">3D演示</div>
						<div v-else class="text_introduce">{{ videoifo.profile }}</div>
					</div>
					<div class="video_category">
						<div class="video_category_title">分集</div>
						<div class="video_category_list">
							<div v-if="type !=0 && type !=6" @click="getVideodetail({ videoId: '3dvideo' })" class="video_category_list" :class="videoId == '3dvideo' ? 'video_category_list_title' : 'video_category_list_subtitle'">
								<img v-if="videoId == '3dvideo'" src="@img/icon/ui_play_y.png" alt />3D演示
							</div>
							<div @click="getVideodetail(item, index)" v-for="(item, index) in videoifo.videos" :key="index" :class="videoId == item.videoId ? 'video_category_list_title' : 'video_category_list_subtitle'">
								<img v-if="videoId == item.videoId" src="@img/icon/ui_play_y.png" alt />
								{{ item.name }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="category_box" v-if="type != 0 && type != 1">
				<div class="category_box_title">
					<span class="line_box"></span>
					<span>对应练习视频</span>
				</div>
				<div class="category_list" v-if="videolist && videolist.length > 0">
					<div v-for="(item, index) in videolist" :key="index" class="category_list_item" @click="getDetail(item)">
						<div class="category_list_img">
							<img :src="item.cover" alt />
						</div>
						<div class="category_list_detail">
							<div class="category_list_title">{{ item.name }}</div>
							<div class="category_list_subtitle">{{ item.profile }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import myvideo from "./myvideo";
export default {
	data() {
		return {
			//动态面包屑标题
			title: "",
			//进入的训练类型
			type: 0,
			// 切换到3d显示对应标题
			isShow3d: false,
			videoId: "",
			videoifo: {},
			videolist: [],
		};
	},
	computed: {
		iframeSrc() {
			return `modal/StandingBroadJump/index.html?scene=${this.type - 1}`;
		},
	},
	components: { myvideo },
	mounted() {
		this.title = this.$route.query.title;
		this.type = this.$route.query.type;
		this.videoId = this.$route.query.videoId;
		this.type == 0 ? this.getVideo() : this.getAllVideo();
	},
	methods: {
		// 分集
		getVideodetail(item, index) {
			// console.log("分集详情", item);
			// this.videoifo = item;
			this.videoId = item.videoId;
			this.videoId == "3dvideo"
				? (this.isShow3d = true)
				: (this.isShow3d = false);
			if (this.videoId !== "3dvideo") this.getAllVideo();
			// else
		},
		// 跳转到视频库详情
		getDetail(item) {
			this.$router.push({
				path: "/Layout/videorack/videodetail",
				query: { videoId: item.videoId },
			});
		},
		// 接口
		getAllVideo() {
			this.$http
				.get("api/video/getAllVideo?videoId=" + this.videoId)
				.then((res) => {
					if (res.success) {
						this.videoifo = res.result;
						this.videolist = res.result.videoList;
						if (this.show3d) {
							this.videoId = "3dvideo";
							this.show3d = false;
						}
					} else {
						this.$message.error(res.message);
					}
				});
		},
		// 单排接口
		getVideo() {
			this.$http
				.get("api/video/getVideoList?videoListId=" + this.videoId)
				.then((res) => {
					if (res.success) {
						this.videoifo = res.result;
						this.videoId = res.result.videoId;
						this.videolist = res.result.videoList;
					} else {
						this.$message.error(res.message);
					}
				});
		},
	},
};
</script>

<style lang="less" scoped>
@import url("~@styles/common.less");

.detail {
	// height: 950px;
	// overflow: auto;
	.main_box {
		overflow: auto;
		height: calc(100vh - 200px);
		padding: 88px 106px;

		&::-webkit-scrollbar {
			width: 0;
		}
	}

	.detai_box {
		display: flex;
		// justify-content: space-between;
		padding: 0 0 28px;
		border-bottom: 1px solid #7070704a;

		.video_box {
			width: 1094px;
			margin-right: 30px;

			video,
			iframe {
				width: 100%;
				height: 615px;
				border: 1px solid #707070;
			}

			.video_title {
				padding: 25px 0 0;
				font-size: 40px;
				font-weight: bold;
				line-height: 52px;
				color: #313131;
			}
		}

		.video_detail_box {
			width: 550px;
			font-weight: 400;

			.text_box {
				padding: 16px 13px;
				border: 1px solid #3131314d;
				border-radius: 5px;

				.text_title {
					font-size: 30px;
					color: #313131;
				}

				.text_introduce {
					padding: 10px 0 0;
					font-size: 22px;
					line-height: 40px;
					color: #31313179;
				}
			}

			.video_category {
				height: 422px;
				overflow: hidden;
				margin: 22px 0 0;
				padding: 13px 16px 40px;
				border: 1px solid #3131314d;
				border-radius: 5px;

				.video_category_title {
					font-size: 30px;
					color: #313131;
				}

				.video_category_list {
					padding: 3px 15px 0 0;
					height: 100%;
					overflow: auto;
					font-size: 22px;
					line-height: 22px;
					color: #313131;

					.video_category_list_title {
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						display: flex;
						align-items: center;
						background: #fff1d1;
						border-radius: 5px;

						img {
							margin-right: 13px;
							width: 26px;
							height: 26px;
						}
					}

					.video_category_list_title,
					.video_category_list_subtitle {
						margin: 11px 0;
						padding: 0 17px;
						height: 50px;
						line-height: 50px;
						cursor: pointer;
					}
				}
			}
		}
	}

	.category_box {
		padding: 25px 0;

		.category_box_title {
			display: flex;
			align-items: center;
			color: #ffa216;
			font-size: 30px;
			height: 37px;
			font-weight: bold;
			line-height: 37px;

			.line_box {
				margin-right: 13px;
				width: 4px;
				height: 100%;
				font-size: 30px;
				font-weight: bold;
				background: #ffa216;
			}
		}

		.category_list {
			margin: 28px 0;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;

			.category_list_item {
				display: flex;
				cursor: pointer;
				margin-bottom: 37px;

				.category_list_img {
					margin-right: 20px;
					width: 280px;
					height: 157px;
					border-radius: 5px;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						border-radius: 5px;
					}
				}

				.category_list_detail {
					width: 400px;

					.category_list_title {
						font-size: 28px;
						font-weight: bold;
						line-height: 28px;
						color: #313131;
					}

					.category_list_subtitle {
						padding: 10px 0 0;
						font-size: 22px;
						font-weight: 400;
						line-height: 40px;
						color: #3131317c;
						text-overflow: ellipsis;
						overflow: hidden;
						display: -webkit-box;
						line-clamp: 3;
						-webkit-line-clamp: 3; //行数
						-webkit-box-orient: vertical;
					}
				}
			}

			// .category_list_item:not(:nth-child(2n)) {
			//   margin-right: calc(12.28% / 3);
			// }
		}
	}
}
</style>